<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!--列表-->

    <el-col :span="4">
      <el-select @change="changestationLineQuery" v-model="selectdm.stationLineID" placeholder="请选择生产线查询映射"
        style="width: 200px">
        <el-option v-for="item in stationLine" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
      </el-select>
    </el-col>
    <el-col :span="3">
      <el-input v-model="selectdm.key" placeholder="仓库名称输入"></el-input>
    </el-col>
    <el-col :span="2">
      <el-button type="primary" @click="getSysRecipeMapping(1)">查询</el-button>
    </el-col>
    <el-col :span="2">
      <el-button type="primary" @click="handleAdd()">添加</el-button>
    </el-col>
    <!--列表-->
    <el-table :data="sysSyncMaterialMapping" highlight-current-row @current-change="selectCurrentRow"
      v-loading="listLoading" @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="MatClassName" label="物资类型" sortable></el-table-column>
      <el-table-column prop="WarehouseName" label="仓库名称" sortable></el-table-column>
      <el-table-column prop="MatName" label="物资名称" sortable></el-table-column>
      <el-table-column prop="PlcField" label="映射字段" sortable></el-table-column>
      <el-table-column prop="StationName" label="生产线" sortable></el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者" sortable></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
            currentRow = scope.row;
            handleEdit();
          }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
            sels.push(scope.row);
            handleDel();
          }
            ">
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--新增界面-->
    <el-dialog :title="isEdit ? '修改' : '新增'" :visible.sync="addFormVisible" v-model="addFormVisible"
      :close-on-click-modal="false">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-form-item label="生产线">
          <el-select @change="changestationLine" v-model="addForm.StationLineID" placeholder="请选择生产线查询映射"
            style="width: 200px">
            <el-option v-for="item in stationLine" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库">
          <el-select v-model="addForm.WarehouseID" filterable @change="whChange">
            <el-option v-for="material in basedata.WarehouseList" :label="material.Name" :key="material.Id"
              :value="material.Id" v-model="material.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物资类型">
          <el-select v-model="addForm.MatClassID" filterable @change="matClassChange">
            <el-option v-for="material in basedata.MaterialClassList" :label="material.Name" :key="material.Id"
              :value="material.Id" v-model="material.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物资">
          <el-select v-model="addForm.MatID" filterable @change="matChange">
            <el-option v-for="material in basedata.MaterialList" :label="material.Name+'('+material.MatGrade+')'" :key="material.Id"
              :value="material.Id" v-model="material.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="映射字段">
          <el-input v-model="addForm.PlcField"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.Remark"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status" v-if="isEdit">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import * as api from "../../api/recipe";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      selectdm: {},
      currentRow: null,
      filters: {
        name: "",
      },
      orgId: "",
      orgCode: "",
      stationLine: [],
      sysSyncMaterialMapping: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        // Name: [
        //   { required: true, message: "请输入单位名称", trigger: "blur" },
        // ],
      },
      //新增界面数据
      basedata: [],
      addForm: {},
      visibleDialog: false,
      isEdit: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getSysRecipeMapping();
    },
    //获取客户列表
    getSysRecipeMapping(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        key: this.selectdm.key,
        stationLineID: this.selectdm.stationLineID,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getSysRecipeMappingListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.sysSyncMaterialMapping = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = this.sels.map((item) => item.Id);
          api.removeSysRecipeMapping(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getSysRecipeMapping();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
      }
      this.isEdit = true;
      this.addFormVisible = true;
      this.addForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.addFormVisible = true;
      this.addForm = { Status: 0 };
    },
    //执行新增
    addSubmit() {
      this.addForm.OrgID = this.orgId;
      this.addForm.OrgCode = this.orgCode;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          if (this.isEdit) {
            api
              .editSysRecipeMapping(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getSysRecipeMapping();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          } else {
            api
              .addSysRecipeMappingPost(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getSysRecipeMapping();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          }
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getSysRecipeMapping(1);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    //获取基础数据
    getBaseData() {
      api.getSysRecipeMappingBaseData().then((res) => {
        this.basedata = res.data.response;
      });
    },
    //改变生产线查询
    changestationLineQuery(val) {
      this.getSysRecipeMapping();
    },
    //改变生产线
    changestationLine(id) {
      var itemLine = this.stationLine.filter((e) => e.Id == id)[0];
      this.addForm.StationLineID = itemLine.Id;
      this.addForm.StationName = itemLine.Name;
    },
    //获取生产线列表
    getSysStationLineList() {
      let para = {
        key: this.orgId,
      };
      this.listLoading = true;
      api
        .getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (this.stationLine && this.stationLine.length > 0) {
            this.addForm.StationLineID = this.stationLine[0].Id;
            this.addForm.StationName = this.stationLine[0].Name;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //获取仓库信息
    whChange(id) {
      var whItem = this.basedata.WarehouseList.filter((x) => x.Id == id)[0];
      this.addForm.WarehouseName = whItem.Name;
      this.addForm.WarehouseID = id;
    },
    //获取类型信息
    matClassChange(id) {
      var matItem = this.basedata.MaterialClassList.filter(
        (x) => x.Id == id
      )[0];
      this.addForm.MatClassName = matItem.Name;
      this.addForm.MatClassID = id;
    },
    //获取类型信息
    matChange(id) {
      var matItem = this.basedata.MaterialList.filter(
        (x) => x.Id == id
      )[0];
      this.addForm.MatName = matItem.Name;
      this.addForm.MatID = id;
    },
    
  },
  mounted() {
    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        this.orgId = JSON.parse(localStorage.currentOrg).Id;
        this.orgCode = JSON.parse(localStorage.currentOrg).OrgCode;
      } else if (localStorage.sysOrgs) {
        this.orgId = JSON.parse(localStorage.sysOrgs)[0].Id;
        this.orgCode = JSON.parse(localStorage.sysOrgs)[0].OrgCode;
      }
    }
    this.getBaseData();
    this.getSysRecipeMapping();
    this.getSysStationLineList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
